<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="golfGroupTbody"
            hide-default-footer
        >
            <template v-slot:[`item.flag`]="{ item }">
                <v-simple-checkbox v-model="item.valid_flag" disabled/>
            </template>
            <template v-slot:[`item.Btn`]="{ item }">
                <v-btn
                    :disabled="btn[3].isActive"
                    color="green darken-4"
                    text
                    @click="editModal(item)"
                    class="editBtn">変更</v-btn>
            </template>
        </v-data-table>
        <v-pagination
            class="my-2"
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            @input="clickPagination"
        />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[2].isActive"
                color="green darken-4"
                text
                @click="addModalView">追加</v-btn>
        </v-card-actions>
        <WithdrawalReasonModal ref="Modal" :editData="findData" @refresh-event="getWithDrawalReason"></WithdrawalReasonModal>
    </div>
</template>

<script>
import { WITH_DRAWAL_REASON } from '@/constants/master';
// import GolfCourseModal from './modal/GolfCourseModal';
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import WithdrawalReasonModal from './modal/WithdrawalReasonModal';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        WithdrawalReasonModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            // 削除時のid
            id: '',
            // v-data-tableのヘッダー
            headers: [
                { text: 'コード', value: 'id', align: 'center', sortable: false },
                { text: '退会理由', value: 'reason', sortable: false },
                { text: '有効フラグ', value: 'flag', align: 'center', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0010'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getWithDrawalReason();
        },
        /** ----------------------------------------------
        * 一覧情報を取得
        * ---------------------------------------------- */
        async getWithDrawalReason () {
            this.desserts = await this.$apollo.mutate({
                mutation: WITH_DRAWAL_REASON,
                variables: {
                    begin_row: this.begin_row,
                    limit_rows: this.limit_rows
                }
            }).then(res => {
                const count = res.data.getWithdrawalReasonCheckbox.count;
                this.pageCount = Math.ceil(count / 10);
                const data = res.data.getWithdrawalReasonCheckbox.WithdrawalReasonCheckboxList;
                data.forEach(ele => {
                    ele.valid_flag = Boolean(ele.valid_flag);
                });
                return res.data.getWithdrawalReasonCheckbox.WithdrawalReasonCheckboxList;
            }).catch(error => { this.error = error; });
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * 子コンポーネントのmodalをtrueにして表示する
        * ---------------------------------------------- */
        addModalView () {
            this.$refs.Modal.addModal();
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/GolfCourseModal.vue'
        * -------------------------------------------- */
        editModal (item) {
            this.findData = this.desserts.find(ele => ele.id === item.id);
            this.$refs.Modal.editModal();
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getWithDrawalReason();
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
